import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "@/lib/productEvents";

/** Records an anonymous page view whenever the route changes. */
export const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackEvent("page_view");
    if (location.pathname.startsWith("/pricing")) {
      trackEvent("pricing_view");
    }
  }, [location.pathname]);

  return null;
};
